import { ref } from 'vue';

/**
 * Permet de déterminer si la structure est sélectionné depuis la carte (map) ou les cartes(cards)
 */
export const isFromCard = ref(false);

/**
* Stocke l'id de la structure sélectionné.
*/
export const selectedStructureId = ref<number | null>();